<template>
    <hts-slide-over
        :show="props.show"
        :title="$t('labels.supplyHistory.title')"
        :width="50"
        @close="closeOverSide">
        <template #body>
            <div class="hts-coordinator-ignore-way__container-body">
                <hts-data-table
                    :headers="supplyHistory"
                    :server="server"
                    :master-detail="true"
                    :is-row-master="isRowMaster"
                    :detail-cell-renderer="SupplyHistoryDetail"
                    :detail-row-height="200" />
            </div>
        </template>
    </hts-slide-over>
</template>
<script lang="ts" setup>
import SupplyHistoryDetail from './supply-history-detail.vue'

const store = $store()
const { $formatters } = useNuxtApp()
const props = defineProps({
  show: {
    type: Boolean,
    default: true,
    required: true
  },
  supplyId: {
    type: String
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'screen-lg'
  },
  column: {
    type: Number,
    default: 3
  }
})
const supplyHistory = [
  {
    field: 'model',
    headerName: $t('labels.companyHistory.model'),
    sortable: true,
    cellRenderer: 'agGroupCellRenderer',
    valueGetter: (params: any) => {
      return checkModelName(params.data.model || '')
    }
  },
  {
    field: 'updatedAt',
    label: 'updatedAt',
    headerName: $t('labels.supplyHistory.dateChanges'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'createdBy',
    label: 'createdBy',
    headerName: $t('labels.supplyHistory.userCreate'),
    sortable: true,
    valueGetter: (params: any) => {
      const users: any[] = store.system.workspaceUsers
      if (users.length === 0) {
        return null
      }
      const user: { [key: string]: any } = computed(() => {
        return users.find((u) => u.user === params.data.createdBy)
      })
      return user.value.fullName
    }
  },
  {
    field: 'updatedBy',
    label: 'updatedBy',
    headerName: $t('labels.supplyHistory.userChange'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data.updatedBy) {
        return ''
      }
      const users: any[] = store.system.workspaceUsers
      if (users.length === 0) {
        return null
      }
      const user: { [key: string]: any } = computed(() => {
        return users.find((u) => u.user === params.data.updatedBy)
      })
      return user.value.fullName
    }
  },
  {
    field: 'action',
    label: 'action',
    headerName: $t('labels.supplyHistory.action'),
    sortable: true,
    valueGetter: (params: any) => {
      let action = params.data.action
      switch (action) {
      case 'CREATE':
        action = $t('labels.create')
        break
      case 'UPDATE':
        action = $t('labels.update')
        break
      case 'DELETE':
        action = $t('labels.delete')
        break
      default:
        break
      }
      return action
    }
  }
]
const server = ref({})
const emits = defineEmits(['close'])
watch(
  () => props.supplyId,
  (newValue: any) => {
    server.value = {
      method: 'post',
      url: '/supply/history/' + newValue
    }
  }
)
const isRowMaster = (dataItem: any) => {
  if (dataItem.action === 'CREATE' || dataItem.action === 'DELETE') {
    return false
  }
  return true
}
const checkModelName = (modelName: string) => {
  switch (modelName) {
  case 'Supply':
    return $t('labels.historyCategory.supply')
  case 'SupplyPlugin':
    return $t('labels.historyCategory.supplyPlugin')
  case 'SupplyInsurance':
    return $t('labels.historyCategory.supplyInsurance')
  case 'SupplyDocument':
    return $t('labels.historyCategory.supplyDocument')
  default:
    break
  }
}
const closeOverSide = () => {
  emits('close')
}
</script>
